import HighlightSection from 'components/HightlightSection/HighlightSection';
import { useAppSelector } from 'hooks/useRedux';
import { Col, Container, Row } from 'react-bootstrap';
import { workflowSelectors } from 'state/workflow';

const ProviderInformation = () => {
  const form = useAppSelector(workflowSelectors.remsFormValuesSelector);
  const provider = form?.values;

  return (
    <>
      {provider && (
        <HighlightSection coloredLineClassName="colored-line-form-wrapper">
          <Container className="px-1 px-md-3">
            <Row
              className="g-0 py-3 py-lg-4 small"
              xs={1}
              sm={3}
            >
              <Col className="mb-2">
                <div className="text-purple fw-bold mb-1">Prescriber Information</div>
                <div>{provider['dummy:prescriber:information:name']}</div>
                <div>{provider['dummy:prescriber:information:location']}</div>
                <div>{provider['dummy:prescriber:information:address']}</div>
                <div>{provider['dummy:prescriber:information:cityStateZip']}</div>
              </Col>
              <Col className="mb-2">
                <div className="text-purple fw-bold mb-1 d-flex">Contact Information</div>
                <div className="d-flex">
                  <div>
                    <div>Phone: </div>
                    <div>Fax: </div>
                    <div>Office Contact: </div>
                    <div>Office Phone: </div>
                  </div>
                  <div className="ms-2">
                    <div>{provider['dummy:prescriber:contact:phone']}</div>
                    <div>{provider['dummy:prescriber:contact:fax']}</div>
                    <div>{provider['dummy:prescriber:contact:officeContact']}</div>
                    <div>{provider['dummy:prescriber:contact:officePhone']}</div>
                  </div>
                </div>
              </Col>
              <Col>
                <div>
                  <div className="text-purple fw-bold mb-1">License Information</div>
                  <div className="d-flex">
                    <div>
                      <div>NPI: </div>
                      <div>DEA: </div>
                      <div>State License: </div>
                    </div>
                    <div className="ms-2">
                      <div>{provider['dummy:prescriber:license:npi']}</div>
                      <div>{provider['dummy:prescriber:license:dea']}</div>
                      <div>{provider['dummy:prescriber:license:stateLicense']}</div>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </HighlightSection>
      )}
    </>
  );
};

export default ProviderInformation;
